import { useQueryClient } from '@tanstack/react-query';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';
import { getActionById } from '../../api/production-request-api/index.js';

/**
 * Hook returning a function for looking up an action's linked action before completing a
 * request. Fired imperatively from a completion handler, reusing the same ACTION_DATA cache
 * entry as useAction so repeat checks for the same action don't refetch.
 */
export const useLinkedActionCheck = () => {
  const queryClient = useQueryClient();

  /**
   * Looks up the given action, rejecting (after a toast) on failure.
   * @param {string} actionId - The action to look up.
   */
  return (actionId) =>
    queryClient
      .fetchQuery({
        queryKey: [QUERY_KEYS.ACTION_DATA, actionId],
        queryFn: () => getActionById(actionId),
      })
      .catch((error) => {
        toast.error('Error checking for linked action.');
        throw error;
      });
};
